const Relationship = () =>
  import(/* webpackChunkName: "cash" */ "@/app/admin/cash/relationship/index");
const CashJob = () =>
  import(/* webpackChunkName: "cash" */ "@/app/admin/cash/job/index");
const Withdrawal = () =>
  import(/* webpackChunkName: "resume" */ "@/app/admin/post/withdrawal");
export default [
  {
    path: "cash",
    name: "cash",
    redirect: "cash/relationship"
  },
  {
    path: "cash/relationship",
    name: "relationship",
    component: Relationship,
    meta: {
      title: "人脉变现",
      key: "relationship",
      permission: "clue_manager.clue_candidate.btn_look_up"
    }
  },
  {
    path: "cash/job",
    name: "cash-job",
    component: CashJob,
    meta: {
      title: "职位变现",
      key: "cash-job",
      permission: "clue_manager.job_clue.btn_look_up"
    }
  },
  {
    path: "withdrawal",
    name: "withdrawal",
    component: Withdrawal,
    meta: { title: "职位变现", permission: "clue_manager" }
  }
];
